import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { Orders } from "../../invoice/models/orders.model";

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private baseRoute: string;
  constructor(private httpClient: HttpClient){
    this.baseRoute = environment.ordersAPIRoot;
  }

  getOrdersInvoicesPreview<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/getordersinvoicespreview`);
  }

  createOrder<T>(payload: Orders): Observable<T> {
    return this.httpClient.post<T>(`${this.baseRoute}/new`, payload);
  }


  getOrder<T>(id: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/getorder/${id}`);
  }

  getOrderWithItems<T>(id: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/getorderwithitems/${id}`);
  }

  getOrders<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/getorders`);
  }

  updateOrder<T>(payload:Orders): Observable<T> {
    return this.httpClient.post<T>(`${this.baseRoute}/update`, payload);
  }

  saveOrder<T>(payload: Orders): Observable<T> {
    if (payload.orderId) {
      return this.httpClient.post<T>(`${this.baseRoute}/update`, payload);
    } else {
      return this.httpClient.post<T>(`${this.baseRoute}/new`, payload);
    }
  }
}
